// Above this a count badge shows "99+".
export const MAX_BADGE_COUNT = 99

/** Text for an unread-count badge: the number, capped at "99+". */
export function formatBadgeCount(count: number): string {
  return count > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : String(count)
}
